export const content = {
  id: {
    nav: {
      problem: "Urgensi",
      ecosystem: "Ekosistem",
      pillars: "Pilar Misi",
      programs: "Program",
      roadmap: "Peta Jalan",
      news: "Kabar",
      join: "Bergabung",
    },
    hero: {
      badge: "Yayasan Gerakan Sehat Otak Indonesia",
      lines: ["Membangun Fondasi", "Brain Energy", "Menuju Indonesia", "Emas 2045"],
      sub: "GESOI adalah gerakan nasional kesehatan otak yang mengubah paradigma dari mengobati penyakit menjadi mengoptimalkan potensi manusia Indonesia.",
      cta1: "Jadilah Arsitek Brain Energy",
      cta2: "Pelajari Gerakan Ini",
      scroll: "Gulir untuk menjelajah",
      launch: "Grand Launching · 17 Agustus 2026",
    },
    marquee: ["Salam Sehat Otak, Indonesia Cerdas", "Sosialisasi", "Edukasi", "Advokasi", "Riset", "Brain Energy", "Indonesia Emas 2045", "Gerakan Nasional", "Otak Sehat"],
    problem: {
      kicker: "01 · Urgensi",
      title: "Realitas yang tersembunyi",
      body: "Bonus demografi Indonesia terancam. Krisis fokus, kecanduan layar, dan tekanan mental generasi muda adalah ancaman diam-diam bagi produktivitas bangsa. Apa yang McKinsey sebut Brain Capital, kami sebut Brain Energy, dan ia harus dibangun sekarang.",
      stats: [
        { value: "6.2%", label: "Remaja Indonesia mengalami depresi" },
        { value: "5.5%", label: "Prevalensi gangguan kesehatan mental" },
        { value: "2045", label: "Batas waktu bonus demografi Indonesia" },
      ],
      paradigmOld: { title: "Paradigma Lama", steps: ["Sakit", "Dokter", "Obat"] },
      paradigmNew: { title: "Paradigma Baru", steps: ["Brain Awareness", "Brain Profiling", "Prevention", "Optimization"] },
      shiftLabel: "bertransformasi menjadi",
    },
    ecosystem: {
      kicker: "02 · Narasi Besar",
      layout: "orbit",
      title: "Satu gerakan, satu ekosistem",
      body: "Indonesia membutuhkan Brain Energy yang sehat untuk mencapai Indonesia Emas 2045. Untuk mencapainya, diperlukan gerakan nasional, GESOI, yang didukung ekosistem yang saling menguatkan.",
      nodes: [
        { name: "PERDOSNI", role: "Otoritas Ilmiah", desc: "Menyediakan validasi ilmiah dan standar neurologi nasional.", icon: "flask" },
        { name: "GESOI", role: "Gerakan Nasional", desc: "Menggerakkan masyarakat melalui edukasi, kampanye, dan advokasi.", icon: "megaphone" },
        { name: "otaQku", role: "Platform Teknologi", desc: "Memberikan teknologi preventif: brain profiling & laporan qEEG.", icon: "cpu" },
        { name: "ICC", role: "Induk Inovasi", desc: "Mengembangkan IP, algoritma, riset, dan ekosistem teknologi.", icon: "network" },
      ],
      coopLabel: "Lima Pilar Kerja Sama",
      cooperation: ["Edukasi", "Aktivasi", "Advokasi", "Kolaborasi", "Riset"],
    },
    pillars: {
      kicker: "03 · Manifesto",
      title: "Empat pilar misi",
      layout: "list",
      items: [
        { num: "01", title: "Edukasi Dini", desc: "Membangun literasi kesehatan neuro sejak usia muda, dari ruang kelas hingga ruang keluarga." },
        { num: "02", title: "Kesadaran Kolektif", desc: "Menormalisasi gaya hidup otak sehat sebagai kebiasaan harian seluruh lapisan masyarakat." },
        { num: "03", title: "Kolaborasi Ekosistem", desc: "Memfasilitasi sinergi antara pemerintah, sektor swasta, dan dunia pendidikan." },
        { num: "04", title: "Identitas Nasional", desc: "Menjadikan kesehatan otak sebagai standar budaya dan penggerak daya saing bangsa." },
      ],
    },
    programs: {
      kicker: "04 · Program & Dampak",
      title: "Mesin penggerak perubahan",
      body: "GESOI tidak menjual teknologi. GESOI menghadirkan dampak sosial: dari sekolah hingga tempat kerja, dari kampanye publik hingga kebijakan nasional.",
      layout: "grid",
      items: [
        { title: "GESOI Goes to School", desc: "Edukasi interaktif Neuro-Hygiene di sekolah: pola tidur, adiksi gawai, dan nutrisi otak.", icon: "school" },
        { title: "Kelas 1000 Hari Otak", desc: "Penyuluhan gratis bagi ibu hamil & menyusui di Posyandu: stimulasi kognitif dan gizi anti-stunting.", icon: "baby" },
        { title: "30-Day Brain Health Challenge", desc: "Kampanye digital kebiasaan ramah otak: jam bebas gawai, olahraga ringan, dan membaca.", icon: "calendar" },
        { title: "Duta Otak Indonesia", desc: "Melatih relawan mahasiswa & tokoh komunitas menjadi edukator kesehatan otak.", icon: "users" },
        { title: "Festival Otak Sehat Nasional", desc: "Acara tahunan: senam otak massal, ekspo kesehatan, serta turnamen puzzle & catur.", icon: "party" },
        { title: "White Book Kesehatan Otak", desc: "Riset tahunan bersama akademisi memetakan indeks kesehatan otak bangsa sebagai acuan kebijakan.", icon: "book" },
      ],
    },
    roadmap: {
      kicker: "05 · Peta Jalan",
      title: "Sepuluh tahun menuju 2045",
      layout: "timeline",
      items: [
        { year: "3 Tahun", title: "Literasi & Pilot", desc: "Literasi publik, pengurangan stigma, dan proyek percontohan di sekolah serta komunitas." },
        { year: "7 Tahun", title: "Integrasi Sistemik", desc: "SDM berbasis otak di sektor pemerintah & swasta; skrining otak menjadi prosedur standar di Puskesmas." },
        { year: "10 Tahun", title: "Infrastruktur Nasional", desc: "Infrastruktur neuro-teknologi di seluruh segmen ekonomi: generasi tangguh, inovatif, dan teregulasi secara emosional." },
      ],
    },
    governance: {
      kicker: "06 · Kepemimpinan",
      title: "Memimpin gerakan nasional otak sehat",
      body: "GESOI dikawal para tokoh nasional lintas sektor dan dikelola secara profesional dengan prinsip Good Corporate Governance serta Dana Abadi untuk keberlanjutan gerakan.",
      note: "Dana Abadi GESOI dirancang tumbuh melalui kemitraan strategis lintas sektor.",
    },
    news: {
      kicker: "07 · Kabar",
      title: "Kabar & kegiatan terbaru",
      backLabel: "Kembali",
      moreLabel: "Berita Lainnya",
      shareLabel: "Bagikan ke WhatsApp",
      notFound: "Berita tidak ditemukan.",
      items: [
        {
          category: "News",
          title: "GESOI resmi dibentuk: fondasi gerakan sehat otak nasional diletakkan",
          date: "12 Juni 2026",
          image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?q=80&w=1200",
          link: "",
          body: "Jakarta - Yayasan Gerakan Sehat Otak Indonesia (GESOI) resmi dibentuk sebagai wadah gerakan nasional untuk kesehatan otak. Pembentukan ini menandai langkah awal perjalanan panjang menuju **Indonesia Emas 2045** melalui paradigma Brain Energy.\n\n## Mengapa gerakan ini penting\n\nKesehatan otak selama ini dipandang semata urusan medis. GESOI hadir untuk mengubah cara pandang tersebut: dari mengobati penyakit menjadi mengoptimalkan potensi manusia Indonesia: di sekolah, tempat kerja, dan keluarga.\n\nDengan dukungan para tokoh nasional lintas sektor, GESOI akan menjalankan program edukasi, aktivasi komunitas, advokasi kebijakan, kolaborasi ekosistem, dan riset.",
        },
        {
          category: "Event",
          title: "Menuju Grand Launching 17 Agustus 2026: deklarasi Gerakan Sehat Otak Indonesia",
          date: "17 Agustus 2026",
          image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1200",
          link: "",
          body: "Gerakan Sehat Otak Indonesia akan dideklarasikan secara resmi pada **17 Agustus 2026**, bertepatan dengan Hari Kemerdekaan Republik Indonesia.\n\nMomentum ini dipilih sebagai simbol: kemerdekaan sejati dimulai dari otak yang sehat: generasi yang fokus, tangguh, dan teregulasi secara emosional.\n\nInformasi lengkap acara akan diumumkan melalui kanal resmi GESOI.",
        },
        {
          category: "News",
          title: "Kolaborasi PERDOSNI × GESOI × otaQku: matriks kerja sama lima pilar disepakati",
          date: "Juni 2026",
          image: "https://images.unsplash.com/photo-1544027993-37dbfe43562a?q=80&w=1200",
          link: "",
          body: "PERDOSNI, GESOI, dan otaQku menyepakati matriks kerja sama lima pilar: **Edukasi, Aktivasi, Advokasi, Kolaborasi, dan Riset**.\n\nSinergi ini mempertemukan otoritas keilmuan neurologi, gerakan sosial nasional, dan inovasi teknologi dalam satu ekosistem yang saling menguatkan untuk kesehatan otak bangsa.",
        },
        {
          category: "Blog",
          title: "Brain Energy: mengapa Indonesia membutuhkannya sekarang",
          date: "Juni 2026",
          image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=1200",
          link: "",
          body: "Brain Energy adalah kerangka berpikir yang menempatkan kesehatan otak sebagai modal utama pembangunan bangsa, yaitu **brain capital**.\n\n## Dari mengobati ke mengoptimalkan\n\nBeban gangguan neurologis dan kesehatan mental terus meningkat, sementara tuntutan ekonomi berbasis pengetahuan makin tinggi. Investasi pada kesehatan otak sejak dini adalah investasi pada daya saing Indonesia.\n\nMelalui edukasi, kebiasaan harian ramah otak, dan kebijakan publik yang berpihak, Indonesia dapat menyiapkan generasi emas 2045.",
        },
      ],
    },
    video: {
      kicker: "08 · Video",
      quote: "Kesehatan otak bukan hanya urusan medis, ia menentukan masa depan keluarga, produktivitas, dan daya saing bangsa. Itulah mengapa gerakan ini begitu mendesak.",
      author: "GESOI",
      role: "Gerakan Sehat Otak Indonesia",
      watchLabel: "Tonton Video",
      url: "https://videos.pexels.com/video-files/3191572/3191572-hd_1280_720_25fps.mp4",
      poster: "https://images.unsplash.com/photo-1544027993-37dbfe43562a?q=80&w=1600",
    },
    publications: {
      kicker: "09 · Publikasi Ilmiah",
      title: "Publikasi ilmiah",
      body: "Akses riset dan white paper kesehatan otak Indonesia. Pendapatan publikasi mendukung keberlanjutan gerakan.",
      buyLabel: "Beli Akses",
      priceNote: "Akses digital (PDF)",
      modalTitle: "Checkout Publikasi",
      cancelLabel: "Batal",
      prototypeNote: "Ini adalah prototipe: pembayaran belum dihubungkan. Tim GESOI akan menghubungi Anda.",
      form: {
        name: "Nama lengkap",
        email: "Alamat email",
        phone: "Nomor WhatsApp",
        organization: "Organisasi (opsional)",
        submit: "Kirim Pesanan",
        sending: "Mengirim...",
        success: "Pesanan tercatat! Tim GESOI akan menghubungi Anda untuk pembayaran & akses.",
        error: "Gagal mengirim pesanan. Periksa isian Anda.",
      },
      items: [
        { title: "White Book Kesehatan Otak Indonesia 2026", authors: "GESOI × Akademisi Mitra", year: "2026", price: "Rp 250.000" },
        { title: "Brain Energy: Kerangka Brain Capital untuk Indonesia Emas 2045", authors: "Tim Riset GESOI", year: "2026", price: "Rp 150.000" },
        { title: "Laporan Indeks Fokus & Kesehatan Kognitif Generasi Muda", authors: "GESOI × PERDOSNI", year: "2026", price: "Rp 200.000" },
      ],
    },
    privacy: {
      banner: "Kami menggunakan cookie untuk meningkatkan pengalaman Anda dan menganalisis kunjungan. Dengan menekan \"Terima\", Anda menyetujui penggunaan cookie.",
      accept: "Terima",
      decline: "Tolak",
      policyLink: "Kebijakan Privasi",
      policyTitle: "Kebijakan Privasi",
      policyText: "Yayasan Gerakan Sehat Otak Indonesia (GESOI) menghormati privasi Anda.\n\n1. Data yang Kami Kumpulkan\nKami mengumpulkan data yang Anda berikan secara sukarela melalui formulir pendaftaran (nama, email, organisasi, minat, dan pesan) serta data teknis dasar seperti jenis peramban dan halaman yang dikunjungi melalui cookie.\n\n2. Penggunaan Data\nData digunakan untuk menghubungi Anda terkait keikutsertaan dalam gerakan, mengirim informasi program, serta meningkatkan kualitas layanan situs ini. Kami tidak menjual atau membagikan data pribadi Anda kepada pihak ketiga tanpa persetujuan.\n\n3. Cookie\nCookie digunakan untuk mengingat preferensi Anda dan menganalisis kunjungan secara agregat. Anda dapat menolak penggunaan cookie melalui banner persetujuan atau pengaturan peramban.\n\n4. Keamanan\nKami menerapkan langkah-langkah teknis yang wajar untuk melindungi data Anda.\n\n5. Hak Anda\nAnda berhak meminta akses, koreksi, atau penghapusan data pribadi Anda dengan menghubungi kami di info@gesoi.or.id.\n\nDengan menggunakan situs ini, Anda menyetujui kebijakan privasi ini. Kebijakan dapat diperbarui sewaktu-waktu.",
    },
    join: {
      kicker: "10 · Ajakan",
      title: "Jadilah Arsitek Brain Energy Indonesia",
      body: "Bergabunglah sebagai relawan, mitra, atau pendukung gerakan. Bersama, kita bangun fondasi Indonesia Emas 2045.",
      form: {
        name: "Nama lengkap",
        email: "Alamat email",
        organization: "Organisasi (opsional)",
        interest: "Saya ingin bergabung sebagai",
        interests: [
          { value: "volunteer", label: "Relawan" },
          { value: "partner", label: "Mitra / Kolaborator" },
          { value: "donor", label: "Donatur" },
          { value: "founder", label: "Founding Circle" },
        ],
        message: "Pesan Anda (opsional)",
        submit: "Kirim & Bergabung",
        sending: "Mengirim...",
        success: "Terima kasih! Kami akan segera menghubungi Anda.",
        error: "Gagal mengirim. Mohon periksa isian Anda.",
        registeredTitle: "Anda telah terdaftar",
        registeredMsg: "Anda telah mendaftar pada {date}. Terima kasih atas antusiasme Anda untuk bergabung dalam gerakan ini! Tim GESOI sedang memproses pendaftaran Anda dengan sepenuh hati, mohon kesabarannya, kami akan segera menghubungi Anda melalui email.",
      },
    },
    footer: {
      tagline: "Membangun Fondasi Brain Energy Menuju Indonesia Emas 2045.",
      address: "Jl. Radio IV No. 5, Jakarta, Indonesia",
      email: "info@gesoi.or.id",
      nav: "Navigasi",
      contact: "Kontak",
      rights: "Yayasan Gerakan Sehat Otak Indonesia. Hak cipta dilindungi.",
      closing: "Salam Sehat Otak, Indonesia Cerdas",
      adminLabel: "Portal Admin",
    },
    seo: {
      title: "GESOI | Gerakan Sehat Otak Indonesia | Brain Energy Menuju Indonesia Emas 2045",
      description: "Yayasan GESOI (Gerakan Sehat Otak Indonesia), gerakan nasional kesehatan otak: mengubah paradigma dari mengobati penyakit menjadi mengoptimalkan potensi menuju Indonesia Emas 2045.",
    },
  },
  en: {
    nav: {
      problem: "Urgency",
      ecosystem: "Ecosystem",
      pillars: "Pillars",
      programs: "Programs",
      roadmap: "Roadmap",
      news: "News",
      join: "Join Us",
    },
    hero: {
      badge: "Indonesian Healthy Brain Movement Foundation",
      lines: ["Building the", "Brain Energy", "Foundation for a", "Golden Indonesia 2045"],
      sub: "GESOI is a national brain health movement, shifting the paradigm from curing illness to optimizing the potential of every Indonesian mind.",
      cta1: "Become a Brain Energy Architect",
      cta2: "Explore the Movement",
      scroll: "Scroll to explore",
      launch: "Grand Launching · August 17, 2026",
    },
    marquee: ["Salam Sehat Otak, Indonesia Cerdas", "Socialization", "Education", "Advocacy", "Research", "Brain Energy", "Golden Indonesia 2045", "National Movement", "Healthy Brains"],
    problem: {
      kicker: "01 · Urgency",
      title: "The hidden reality",
      body: "Indonesia's demographic bonus is at risk. A crisis of focus, screen addiction, and youth mental strain silently threatens national productivity. What McKinsey calls Brain Capital, we call Brain Energy, and it must be built now.",
      stats: [
        { value: "6.2%", label: "Indonesian youth experiencing depression" },
        { value: "5.5%", label: "Prevalence of mental health disorders" },
        { value: "2045", label: "Deadline of Indonesia's demographic bonus" },
      ],
      paradigmOld: { title: "Old Paradigm", steps: ["Illness", "Doctor", "Medicine"] },
      paradigmNew: { title: "New Paradigm", steps: ["Brain Awareness", "Brain Profiling", "Prevention", "Optimization"] },
      shiftLabel: "transforms into",
    },
    ecosystem: {
      kicker: "02 · Grand Narrative",
      layout: "orbit",
      title: "One movement, one ecosystem",
      body: "Indonesia needs healthy Brain Energy to reach a Golden Indonesia 2045. Achieving it requires a national movement, GESOI, powered by a mutually reinforcing ecosystem.",
      nodes: [
        { name: "PERDOSNI", role: "Scientific Authority", desc: "Provides scientific validation and national neurology standards.", icon: "flask" },
        { name: "GESOI", role: "National Movement", desc: "Mobilizes society through education, campaigns, and advocacy.", icon: "megaphone" },
        { name: "otaQku", role: "Technology Platform", desc: "Delivers preventive technology: brain profiling & qEEG reports.", icon: "cpu" },
        { name: "ICC", role: "Innovation Parent", desc: "Develops IP, algorithms, research, and the technology ecosystem.", icon: "network" },
      ],
      coopLabel: "Five Pillars of Cooperation",
      cooperation: ["Education", "Activation", "Advocacy", "Collaboration", "Research"],
    },
    pillars: {
      kicker: "03 · Manifesto",
      title: "Four pillars of mission",
      layout: "list",
      items: [
        { num: "01", title: "Early Education", desc: "Building neuro-health literacy from a young age, from classrooms to living rooms." },
        { num: "02", title: "Collective Awareness", desc: "Normalizing a healthy brain lifestyle as a daily habit across all of society." },
        { num: "03", title: "Ecosystem Collaboration", desc: "Facilitating synergy between government, private sector, and education." },
        { num: "04", title: "National Identity", desc: "Making brain health a cultural standard and driver of national competitiveness." },
      ],
    },
    programs: {
      kicker: "04 · Programs & Impact",
      title: "The engine of change",
      body: "GESOI does not sell technology. GESOI delivers social impact: from schools to workplaces, from public campaigns to national policy.",
      layout: "grid",
      items: [
        { title: "GESOI Goes to School", desc: "Interactive Neuro-Hygiene education in schools: sleep, gadget addiction, and brain nutrition.", icon: "school" },
        { title: "1000 Days of the Brain Class", desc: "Free counseling for pregnant & nursing mothers at community health posts: cognitive stimulation and anti-stunting nutrition.", icon: "baby" },
        { title: "30-Day Brain Health Challenge", desc: "Digital campaign for brain-friendly habits: gadget-free hours, light exercise, and reading.", icon: "calendar" },
        { title: "Duta Otak Indonesia", desc: "Training student volunteers & community leaders to become brain health educators.", icon: "users" },
        { title: "National Healthy Brain Festival", desc: "Annual event: mass brain exercises, health expos, plus puzzle & chess tournaments.", icon: "party" },
        { title: "Brain Health White Book", desc: "Annual research with academics mapping the nation's brain health index as a policy reference.", icon: "book" },
      ],
    },
    roadmap: {
      kicker: "05 · Roadmap",
      title: "Ten years toward 2045",
      layout: "timeline",
      items: [
        { year: "3 Years", title: "Literacy & Pilots", desc: "Public literacy, stigma reduction, and pilot projects in schools and communities." },
        { year: "7 Years", title: "Systemic Integration", desc: "Brain-based HR in government & private sectors; brain screenings as standard practice in public health clinics." },
        { year: "10 Years", title: "National Infrastructure", desc: "Neuro-technology infrastructure across all economic segments: a resilient, innovative, emotionally regulated generation." },
      ],
    },
    governance: {
      kicker: "06 · Leadership",
      title: "Leading a national movement for brain health",
      body: "GESOI is guided by national cross-sector figures and professionally managed under Good Corporate Governance principles, with an Endowment Fund for the movement's sustainability.",
      note: "The GESOI Endowment Fund is designed to grow through cross-sector strategic partnerships.",
    },
    news: {
      kicker: "07 · Updates",
      title: "Latest news & activities",
      backLabel: "Back",
      moreLabel: "More News",
      shareLabel: "Share on WhatsApp",
      notFound: "Article not found.",
      items: [
        {
          category: "News",
          title: "GESOI officially formed: foundation of the national healthy brain movement laid",
          date: "June 12, 2026",
          image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?q=80&w=1200",
          link: "",
          body: "Jakarta - The Indonesian Healthy Brain Movement Foundation (GESOI) has been officially established as the home of a national movement for brain health. This marks the first step of a long journey toward **Golden Indonesia 2045** through the Brain Energy paradigm.\n\n## Why this movement matters\n\nBrain health has long been seen as a purely medical matter. GESOI exists to change that perspective: from treating disease to optimizing the potential of the Indonesian people: in schools, workplaces, and families.\n\nBacked by national cross-sector figures, GESOI will run programs in education, community activation, policy advocacy, ecosystem collaboration, and research.",
        },
        {
          category: "Event",
          title: "Toward the Grand Launching, August 17, 2026: declaring the Indonesian Healthy Brain Movement",
          date: "August 17, 2026",
          image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1200",
          link: "",
          body: "The Indonesian Healthy Brain Movement will be officially declared on **August 17, 2026**, coinciding with the Independence Day of the Republic of Indonesia.\n\nThe moment was chosen as a symbol: true independence begins with a healthy brain: a generation that is focused, resilient, and emotionally regulated.\n\nFull event details will be announced through GESOI's official channels.",
        },
        {
          category: "News",
          title: "PERDOSNI × GESOI × otaQku collaboration: five-pillar cooperation matrix agreed",
          date: "June 2026",
          image: "https://images.unsplash.com/photo-1544027993-37dbfe43562a?q=80&w=1200",
          link: "",
          body: "PERDOSNI, GESOI, and otaQku have agreed on a five-pillar cooperation matrix: **Education, Activation, Advocacy, Collaboration, and Research**.\n\nThis synergy brings together neurological scientific authority, a national social movement, and technological innovation in one mutually reinforcing ecosystem for the nation's brain health.",
        },
        {
          category: "Blog",
          title: "Brain Energy: why Indonesia needs it now",
          date: "June 2026",
          image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=1200",
          link: "",
          body: "Brain Energy is a framework that positions brain health as the nation's primary development asset, **brain capital**.\n\n## From treating to optimizing\n\nThe burden of neurological and mental health disorders keeps rising, while the demands of a knowledge-based economy grow ever higher. Investing in brain health from an early age is investing in Indonesia's competitiveness.\n\nThrough education, brain-friendly daily habits, and supportive public policy, Indonesia can prepare its golden generation of 2045.",
        },
      ],
    },
    video: {
      kicker: "08 · Video",
      quote: "Brain health is not just a medical matter, it shapes the future of families, productivity, and national competitiveness. That is why this movement is so urgent.",
      author: "GESOI",
      role: "Indonesian Healthy Brain Movement",
      watchLabel: "Watch The Video",
      url: "https://videos.pexels.com/video-files/3191572/3191572-hd_1280_720_25fps.mp4",
      poster: "https://images.unsplash.com/photo-1544027993-37dbfe43562a?q=80&w=1600",
    },
    publications: {
      kicker: "09 · Scientific Publications",
      title: "Scientific publications",
      body: "Access Indonesian brain health research and white papers. Publication revenue supports the movement's sustainability.",
      buyLabel: "Buy Access",
      priceNote: "Digital access (PDF)",
      modalTitle: "Publication Checkout",
      cancelLabel: "Cancel",
      prototypeNote: "This is a prototype: payment is not yet connected. The GESOI team will contact you.",
      form: {
        name: "Full name",
        email: "Email address",
        phone: "WhatsApp number",
        organization: "Organization (optional)",
        submit: "Place Order",
        sending: "Sending...",
        success: "Order recorded! The GESOI team will contact you for payment & access.",
        error: "Failed to send order. Please check your details.",
      },
      items: [
        { title: "Indonesian Brain Health White Book 2026", authors: "GESOI × Academic Partners", year: "2026", price: "Rp 250.000" },
        { title: "Brain Energy: A Brain Capital Framework for Golden Indonesia 2045", authors: "GESOI Research Team", year: "2026", price: "Rp 150.000" },
        { title: "Youth Focus & Cognitive Health Index Report", authors: "GESOI × PERDOSNI", year: "2026", price: "Rp 200.000" },
      ],
    },
    privacy: {
      banner: "We use cookies to improve your experience and analyze visits. By clicking \"Accept\", you consent to the use of cookies.",
      accept: "Accept",
      decline: "Decline",
      policyLink: "Privacy Policy",
      policyTitle: "Privacy Policy",
      policyText: "Yayasan Gerakan Sehat Otak Indonesia (GESOI) respects your privacy.\n\n1. Data We Collect\nWe collect data you voluntarily provide through the registration form (name, email, organization, interest, and message) as well as basic technical data such as browser type and pages visited via cookies.\n\n2. Use of Data\nData is used to contact you regarding participation in the movement, send program information, and improve this site. We do not sell or share your personal data with third parties without consent.\n\n3. Cookies\nCookies are used to remember your preferences and analyze visits in aggregate. You may decline cookies via the consent banner or your browser settings.\n\n4. Security\nWe apply reasonable technical measures to protect your data.\n\n5. Your Rights\nYou may request access, correction, or deletion of your personal data by contacting info@gesoi.or.id.\n\nBy using this site you agree to this privacy policy. The policy may be updated from time to time.",
    },
    join: {
      kicker: "10 · Call to Action",
      title: "Become an Architect of Indonesia's Brain Energy",
      body: "Join as a volunteer, partner, or supporter of the movement. Together, we build the foundation of a Golden Indonesia 2045.",
      form: {
        name: "Full name",
        email: "Email address",
        organization: "Organization (optional)",
        interest: "I want to join as",
        interests: [
          { value: "volunteer", label: "Volunteer" },
          { value: "partner", label: "Partner / Collaborator" },
          { value: "donor", label: "Donor" },
          { value: "founder", label: "Founding Circle" },
        ],
        message: "Your message (optional)",
        submit: "Send & Join",
        sending: "Sending...",
        success: "Thank you! We will be in touch soon.",
        error: "Failed to send. Please check your details.",
        registeredTitle: "You are registered",
        registeredMsg: "You registered on {date}. Thank you for your enthusiasm to join this movement! The GESOI team is processing your registration wholeheartedly, please bear with us, we will reach out to you by email soon.",
      },
    },
    footer: {
      tagline: "Building the Brain Energy Foundation Towards a Golden Indonesia 2045.",
      address: "Jl. Radio IV No. 5, Jakarta, Indonesia",
      email: "info@gesoi.or.id",
      nav: "Navigation",
      contact: "Contact",
      rights: "Yayasan Gerakan Sehat Otak Indonesia. All rights reserved.",
      closing: "Salam Sehat Otak, Indonesia Cerdas",
      adminLabel: "Admin Portal",
    },
    seo: {
      title: "GESOI | Gerakan Sehat Otak Indonesia | Brain Energy Towards a Golden Indonesia 2045",
      description: "GESOI Foundation (Indonesian Healthy Brain Movement), a national brain health movement: shifting the paradigm from treating disease to optimizing potential towards a Golden Indonesia 2045.",
    },
  },
};

export const sharedDefaults = {
  logo: "https://customer-assets.emergentagent.com/job_social-impact-web-2/artifacts/e6k8en9x_image.png",
  favicon: "https://customer-assets.emergentagent.com/job_social-impact-web-2/artifacts/e6k8en9x_image.png",
  ogImage: "/hero-bg-light.webp",
  theme: { navy: "#0A192F", emerald: "#059669", gold: "#B45309" },
  sections: [
    { key: "marquee", visible: true },
    { key: "problem", visible: true },
    { key: "ecosystem", visible: true },
    { key: "pillars", visible: true },
    { key: "programs", visible: true },
    { key: "roadmap", visible: true },
    { key: "governance", visible: true },
    { key: "news", visible: true },
    { key: "video", visible: true },
    { key: "publications", visible: true },
    { key: "join", visible: true },
  ],
  heroBg: "/hero-bg-light.webp",
  programsImage: "https://images.unsplash.com/photo-1611087802810-046bb671e644?q=80&w=1200",
  joinBg: "https://images.pexels.com/photos/18772861/pexels-photo-18772861.jpeg",
  people: [
    { name: "Rudiantara", role_id: "Ketua Konsil Penasehat Kehormatan", role_en: "Chair, Honorary Advisory Council", photo: "" },
    { name: "Andrew Tani", role_id: "Ketua Dewan Pengurus", role_en: "Chair, Board of Executives", photo: "" },
    { name: "Ari Dwipayana", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Arwin Rasyid", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Bacelius Ruru", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Bambang Sudibyo", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Burhanuddin Abdullah", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Chu Shen", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Gandhi Sulistiyanto", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Julian Foe", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Mia Lauder", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Roger Finnie", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Sandiaga Uno", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Sanny Iskandar", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Theodore Permadi Rachmat", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Widya Priyahita Pudjibudojo", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
    { name: "Yudi Latif", role_id: "Konsil Penasehat Kehormatan", role_en: "Honorary Advisory Council", photo: "" },
  ],
};
